/** Reloj de inactividad (puro, sin window). 1 hora sin interacción → reset al entrar de nuevo. */

export const IDLE_TIMEOUT_MS = 60 * 60 * 1000;

/** SSO / recarga: no usar un timestamp viejo para expulsar a ?reason=idle. */
export function shouldResetIdleClock(lastActivityAt, nowMs = Date.now(), timeoutMs = IDLE_TIMEOUT_MS) {
  if (lastActivityAt == null) return true;
  const last = Number(lastActivityAt);
  if (!Number.isFinite(last) || last <= 0) return true;
  return nowMs - last >= timeoutMs;
}
